import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import $ from 'jquery';
import './Marathon.css';
import './legend.css';
import './Mapbox.css';
import jetBlue_logo from '../images/jetblue.png'; // Tell Webpack this JS file uses this image

export default class BostonMarathon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    }
    this.openDialog = this.openDialog.bind(this);
    this.hide = this.hide.bind(this);
    this.toggleCliffZones = this.toggleCliffZones.bind(this);
  }

  toggleCliffZones() {
    const {
      map
    } = this.props;
    $('.route-markers').fadeOut('fast');
    const layer = 'cliffZones';

    var visibility = map.getLayoutProperty(layer, 'visibility');
    if (visibility === 'visible') {
      map.setLayoutProperty(layer, 'visibility', 'none');
    } else {
      map.setLayoutProperty(layer, 'visibility', 'visible');
    }
  }

  toggleMarkers(className) {
    $(className).fadeToggle();
    $('.route-markers').not( $(className) ).fadeOut('fast');
    this.props.map.setLayoutProperty('cliffZones', 'visibility', 'none');
  }

  openDialog() {
    this.setState({open: true});
  }

  hide() {
    this.setState({open: false});
  }

  render () {
    const styles = {
      dialogStyle: {
        width: '95%',
      }
    }

    return (
      <div>
        <div className="jetblue-container">
          <a href="https://www.jetblue.com/" target="_blank">
            <img src={jetBlue_logo}
              className="jetblue-image"
              alt="JetBlue Logo" />
          </a>
        </div>
        <Dialog
          modal={false}
          open={this.state.open}
          onRequestClose={this.hide}
          contentStyle={styles.dialogStyle}
          autoScrollBodyContent={true}
          contentClassName="more-info-dialog"
          actions={[
            <FlatButton
              label="Close"
              onClick={this.hide}
            />
          ]}
        >
          <div className="sign-in-text">
            The historic course starts on Main Street in the rural New England town of Hopkinton and follows Route 135 through Ashland, Framingham, Natick, and Wellesley to where Route 16 joins Route 135. It continues on Route 16 through Newton Lower Falls to Commonwealth Avenue, turning right at the fire station onto Commonwealth which is Route 30. It continues on Commonwealth through the Newton Hills, bearing right at the reservoir onto Chestnut Hill Avenue to Cleveland Circle. The route then turns left onto Beacon Street continuing to Kenmore Square, and then follows Commonwealth Avenue inbound. The course turns right onto Hereford Street (NOTE: against normal traffic flow) then left onto Boylston Street, finishing near the John Hancock Tower in Copley Square.
            <br /><br/>
            <p className="copyright">
              © 2017. All rights reserved. No portion of the map may be reproduced without permission of the Boston Athletic Association. Boston Marathon®, B.A.A. Marathon <sup>TM</sup>, and the B.A.A. Unicorn logo are registered trademarks of the Boston Athletic Association. Use of these trademarks without written permission from the Boston Athletic Association is prohibited.
            </p>
          </div>
        </Dialog>
        <div className="legend">
          <div className="legend-header">
            Toggle features:
          </div>
          <div className="legend-item"
            onClick={() => this.toggleMarkers('.mile-marker')}>
            <div className="mile-marker-legend-item">1</div> Mile Markers
          </div>
          <div className="legend-item"
            onClick={() => this.toggleMarkers('.km-marker')}>
            <div className="km-marker-legend-item">10k</div> Km Markers
          </div>
          <div className="legend-item"
            onClick={() => this.toggleMarkers('.hydration-station')}>
            <div className="hydration-station-legend-item">
              <svg width="100%" height="100%" viewBox="0 0 30 42" preserveAspectRatio="xMaxYMax">
                <path fill="#27a7df" stroke="#fff" strokeWidth="1.5" d="M15 3
                  Q16.5 6.8 25 18
                  A12.8 12.8 0 1 1 5 18
                  Q13.5 6.8 15 3z"></path>
             </svg>
            </div> Hydration Stations
          </div>
          <div className="legend-item"
            onClick={this.toggleCliffZones}>
            <div className="clif-legend-item">
              <img alt="Clif Energy Zone" src="/logos/clif.jpg" className="clif-image-legend" />
            </div>
          </div>
          <div className="legend-item"
            onClick={() => this.toggleMarkers('.medical-station')}>
            <div className="medical-station-legend" /> Medical Stations
          </div>
          <div className="legend-item"
            onClick={() => this.toggleMarkers('.t-station')}>
            <div className="t-station-legend-item">T</div> T Stations
          </div>
          <div className="legend-item"
            onClick={() => this.toggleMarkers('.toilet')}>
            Public restrooms
          </div>
          <div className="legend-item"
            onClick={this.openDialog}>
            <div className="more-info-legend-item">
              More information
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/marathon/BostonMarathon.jsx